import React, { Component } from "react";
import {
  Text,
  View,
  Image,
  ScrollView,
  Dimensions,
  TouchableOpacity,
  Platform,
  Animated,
  TextInput,
} from "react-native";
import {
  postSingle,
  Flex,
  Padding,
  Margin,
  Helpers,
  button,
  appHeader,
  Typo,
  FontWeight,
  FontFamily,
  Colors,
  formStyle,
  teamSubscription,
} from "../../styles/appStyles";
import TouchableOpacityLink from "../touchable-opacity-link";
import TouchableOpacityLinkExternal from "../touchable-opacity-link-external";
import { helpers } from "../../utils/helpers";
import apiHelpers from "../../utils/api-helpers";
import SubscriptionPlanModal from "../subscription-plan-modal";
import SidebarCheck from "../sidebar-check";
import CustomImage from "../custom-image";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  removeUserToken,
  setUserStatus,
} from "../../../redux/User/user.actions";
import { saveDarkMode, darkModeToggle } from "../../../redux/App/app.actions";
import getImagePath from "../../utils/image-helper";
import Cookies from "universal-cookie";
import ButtonGradient from "../button-gradient";
import Button from "../button";
import { Mixpanel } from "../../utils/mixpanel";
import { GoogleAnalytics } from "../../utils/google-analytics";
import VerifyDocumentModal from "../verify-document-modal";
import GiftCardModal from "../gift-card-modal";
import { withAuth0 } from "@auth0/auth0-react";
import AuthenticationWrapper from "../authentication-wrapper";
import PlanAlert from "../plan-alert";
import config from "react-native-config";

const cookies = new Cookies();

const bookmarkMultiple = getImagePath("icons/bookmark-multiple-light.png");
const bookmarkMultipleDark = getImagePath("icons/bookmark-multiple-white.png");

const menuIconDesk = getImagePath("icons/hamburger-menu-desk.png");
const menuIconMob = getImagePath("icons/hamburger-menu-mob.png");
const menuIconDeskDark = getImagePath("icons/hamburger-menu-deskDark.png");
const menuIconMobDark = getImagePath("icons/hamburger-menu-mobDark.png");

const searchIcon = getImagePath("icons/search.png");
const appLogo = getImagePath("icons/tmc-logo.png");

const closeIcon = getImagePath("icons/close-icon.png");
const closeBoxIcon = getImagePath("icons/close-round.png");
const userIcon = getImagePath("icons/userIcon.png");
const userIconLight = getImagePath("icons/search.png");
const userIconOffWhite = getImagePath("icons/userIconOffWhite.png");
const userIconFilledWhite = getImagePath("icons/userIconFilledLight.png");

const closeMsgIcon = getImagePath("icons/close-icon-white.png");
const whiteTick = getImagePath("icons/whiteTick.png");
const whiteClock = getImagePath("icons/whiteClock.png");

const searchBox = getImagePath("icons/searchbox.png");
const editProfile = getImagePath("icons/editProfile.png");

const Facebook = getImagePath("icons/facebook-b.png");
const Twitter = getImagePath("icons/twitterGrey.png");
const Linkedin = getImagePath("icons/linkedlngrey.png");

const FacebookDark = getImagePath("icons/facebook-light.png");
const TwitterDark = getImagePath("icons/twitter-light.png");
const LinkedinDark = getImagePath("icons/linkedin-light.png");

const closeIconWhite = getImagePath("icons/close-icon-white.png");

const notificationClose = getImagePath("icons/fileRemoveIcon.png");
const notificationCloseDark = getImagePath("icons/fileRemoveIconDark.png");

const successIcon = getImagePath("icons/success.png");

const windowWidth = Dimensions.get("window").width;

import { ChargebeeController } from '../../utils/chargebee'


export class AppHeader extends Component {
  constructor(props) {
    super(props);
    const { isAuthenticated, fetchToken } = this.props.auth;
    let token = process.browser
      ? isAuthenticated
        ? fetchToken
        : false
      : this.props.token;
    let tokenSet = token == undefined || token == "" ? false : true;

    if (process.browser && window.location.search) {
      let searchArr = window.location.search.replace("?", "").split("&");
      let redirectParams;
      redirectParams = searchArr.find((searchParam) => {
        return searchParam.includes("redirect-params=");
      });
      if (redirectParams) {
        redirectParams = redirectParams.replace("redirect-params=", "");
      }
      if (redirectParams) {
        let reaplaceProp = JSON.parse(JSON.stringify(window.location));
        reaplaceProp.search = redirectParams + "&close-modal=true";
        this.props.history.replace(reaplaceProp);
      }
    }

    this.state = {
      slideMenu: new Animated.Value(-(windowWidth * 2)),
      searchbar: new Animated.Value(-(windowWidth * 2)),
      token: tokenSet ? token : false,
      showToken: process.browser ? true : false,
      siteText: "The Morning Context",
      userProfile: false,
      showLogin: tokenSet ? false : true,
      showUser: false,
      showSubscribe: false,
      selectedSubscribtionID: false,
      paymentConfig: {},
      billingPlatform: false,
      chargebeeSite: false,
      chargebeeSiteKey: false,
      chargebeePublishableKey: false,
      // subscriptionStatus: false,
      querySubscribtionID: false,
      selectedSubscribtion: false,
      subscribeEmail: false,
      country: false,
      locationHash: "",
      searchText: "",
      quantity: 1,
      copyright: this.props.footerData
        ? this.props.footerData.copyright
        : false,
      pressedBtn: false,
      showModal: new Animated.Value(0),
      showStatus: new Animated.Value(1),
      readingValue: new Animated.Value(0),
      showStatus: new Animated.Value(1),
      hideHeader: this.props.hideHeader,
      documentStatus: "default",
      submittedFiles: [],
      openStudentModal: false,
      documentUploadDate: "",
      openSearch: false,
      chargebeeSiteIN: helpers.isWeb()
        ? process.env.CHARGEBEE_SITE_IN
        : config.CHARGEBEE_SITE_IN,
      chargebeeSiteKeyIN: helpers.isWeb()
        ? process.env.CHARGEBEE_API_KEY_IN
        : config.CHARGEBEE_API_KEY_IN,
      chargebeeSiteOT: helpers.isWeb()
        ? process.env.CHARGEBEE_SITE_OT
        : config.CHARGEBEE_SITE_OT,
      chargebeeSiteKeyOT: helpers.isWeb()
        ? process.env.CHARGEBEE_API_KEY_OT
        : config.CHARGEBEE_API_KEY_OT,
      chargebeePubKeyIN: helpers.isWeb()
        ? process.env.CHARGEBEE_API_KEY_IN
        : config.CHARGEBEE_API_KEY_IN,
      chargebeePubKeyOT: helpers.isWeb()
        ? process.env.CHARGEBEE_API_KEY_OT
        : config.CHARGEBEE_API_KEY_OT,
    };
    // this.wrapperRef = React.createRef();
    // this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  // handleClickOutside(event) {
  //   console.log("event:", event);

  //   this.toggleSlideMenu(false);
  // }


    componentDidMount = () => {
        window.onscroll = () => { this.scrollFunction() };
        if (this.state.token) {
           this.getUserInfo();
        } else {
            this.setDarkMode('off');
            this.checkQuery();
        }
        this.checkHash();
        this.getHeaderMenu();
        /* Commented because an uneccessary page reload is triggered */
        // this.refreshPlans()
        // this.showChargbeePage(null);
        this.checkAdvanceRenewal()

    }

    componentWillUnmount = () => {
    }

    componentDidUpdate = () => {
        let token = this.props.auth.fetchToken;
        if (token != this.state.token) {
            let tokenSet = (token == undefined || token == '') ? false : true;
            this.setState({
                token: tokenSet ? token : false,
                showLogin: tokenSet ? false : true,
                userProfile: false,
                showUser: false,
                showSubscribe: false,
            }, () => {
                if (this.state.token) {
                    /* Duplicate or redundant call for user info */
                    // this.getUserInfo();
                }
                if (this.state.selectedSubscribtionID) {
                    this.refreshPlans();
                }
            });
        }
        if (this.state.token == false || this.state.userProfile) {
            this.checkQuery();
        }
        this.checkHash();
        if (this.state.hideHeader != this.props.hideHeader) {
            this.setState({ hideHeader: this.props.hideHeader });
            Animated.timing(this.state.showModal, {
                toValue: this.props.hideHeader ? -70 : 0,
                duration: 500,
                delay: 0,
                useNativeDriver: true
            }).start();
            Animated.timing(this.state.showStatus, {
                toValue: this.props.hideHeader ? 0 : 1,
                duration: 500,
                delay: 0,
                useNativeDriver: true
            }).start();
        }

    }

    checkAdvanceRenewal = () => {


        const urlParams = helpers.getURLParamDict(window.location.href)
        if(!(urlParams['advance-renew'] === 'true')){
            return
        }
        if(this.loginRequired()){
            console.log('chargebee: login-check-1')
            return;
        }

        ChargebeeController.activatedController().then(cb_handle => {
            if(!ChargebeeController.hosted_page.parameterHandle.getParam('subscription.id')){
                console.log('chargebee: advance_renewal not allowed: ')
                return;
            }

            if(!helpers.canAdvanceRenew(cb_handle.activeSubscription)){
              console.log('chargebee: advance_renewal not allowed: ')
              return;
            }
            cb_handle.hosted_page.checkout_existing({
                terms_to_charge: 1,
                invoice_immediately: true
            }, {
                close: [
                    () => {
                        let newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`
                        window.history.pushState({path: newurl}, '', newurl)
                    }
                ]
            }, false)
        })
    }

    loginRequired = () => {
        if(!this.state.token){

            let encodedRedirectURL = `${this.props.redirectSlugs.web}${window.location.search}`
            encodedRedirectURL = encodeURIComponent(encodedRedirectURL)
            let redirect_url = `/sign-in?encoded=1&redirect=${encodedRedirectURL}`
            console.log('chargebee: forced-login: ', window.location.search.substring(1))

            this.props.navigateWeb(redirect_url)

            return true;
        }
        return false
    }
    animateReadingList = () => {
        this.setState({ readingValue: new Animated.Value(0) }, () => {
            Animated.timing(this.state.readingValue, {
                toValue: 60,
                duration: 800
            }).start();
        })
    }


  setDarkMode = (darkMode, toggle) => {
    this.setState({
      darkMode: darkMode,
    });
    this.props.saveDarkMode(darkMode);
    this.props.darkModeToggle(toggle ? true : false);
    let cookieDate = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000);
    cookies.set("dark_mode", darkMode, { path: "/", expires: cookieDate });
  };

  getHeaderMenu = () => {
    const { token } = this.state;
    let endpoint = `/header-menu`;
    apiHelpers
      .apiRequest(endpoint, {}, "GET", true, token)
      .then((res) => {
        if (res.success && res.code == "header_menu") {
          this.setState({
            menuItems: res.data.menu,
            copyright: res.data.copyright,
          });
        } else {
          console.log("Error=>>", res);
        }
      })
      .catch((error) => {
        console.log("Error=>>", error);
      });
  };

  refreshPlans = () => {
    const { token } = this.state;
    let endpoint = `/plans/default`;
    let body = {
      filters: {
        tmc_group: [
          "individual",
          "credit",
          "team",
          "team_credit",
          "student",
          "gift_plan",
          "gift_credit",
        ],
      },
    };
    apiHelpers
      .apiRequest(endpoint, body, "POST", true, token)
      .then((res) => {
        if (res.code == "access_denied") {
          this.authTokenExpired();
          return false;
        }
        if (res.success) {
          this.setState({
            country: res.data.country,
          });
          if (this.state.selectedSubscribtionID == "credits") {
            this.setState({
              selectedSubscribtion: res.data.plans.credit[0],
              country: res.data.country,
            });
            return false;
          }
          let queryPlan =
            res.data.plans.individual.find(
              (plan) => plan.id == this.state.selectedSubscribtionID
            ) ||
            res.data.plans.team.find(
              (plan) => plan.id == this.state.selectedSubscribtionID
            ) ||
            res.data.plans.student.find(
              (plan) => plan.id == this.state.selectedSubscribtionID
            ) ||
            res.data.plans.team_credit.find(
              (plan) => plan.id == this.state.selectedSubscribtionID
            ) ||
            res.data.plans.gift_credit.find(
              (plan) => plan.id == this.state.selectedSubscribtionID
            ) ||
            res.data.plans.gift_plan.find(
              (plan) => plan.id == this.state.selectedSubscribtionID
            );

          if (queryPlan) {
            this.setState({
              selectedSubscribtion: queryPlan,
              country: res.data.country,
            });
          } else {
            this.closeSubscriptionPlanModal();
            console.log("Plan not found");
          }
        } else {
          console.log("Error=>>", res);
        }
      })
      .catch((error) => {
        console.log("Error=>>", error);
      });
  };

  checkHash = () => {
    if (this.props.locationHash != this.state.locationHash) {
      this.setState(
        {
          locationHash: this.props.locationHash,
        },
        () => {
          if (this.props.locationHash == "") {
            if (this.props.refreshPage) {
              this.props.refreshPage();
            }
          }
        }
      );
    }

    this.yesterdayScreen = window.location.pathname.split('/');
    this.isYesterdayScreenEnable = false;
    if (this.yesterdayScreen.length >= 3 && this.yesterdayScreen[1] == "yesterday") {
      this.isYesterdayScreenEnable = true
    } else
      this.isYesterdayScreenEnable = false

    localStorage.setItem('isYesterdayScreenEnable', this.isYesterdayScreenEnable ? "1" : "0");
  };

  checkQuery = () => {
      const { token } = this.state;
      if (this.props.searchQuery && (this.props.searchQuery.includes("subscribe=") || this.props.searchQuery.includes("buy-credits=true")) && this.state.querySubscribtionID == false) {

        if(!token){

            let encodedRedirectURL = `${this.props.redirectSlugs.web}${window.location.search}`
            encodedRedirectURL = encodeURIComponent(encodedRedirectURL)
            let redirect_url = `/sign-in?encoded=1&redirect=${encodedRedirectURL}`

            this.props.navigateWeb(redirect_url)

            return;
        }

        let searchArr = this.props.searchQuery.replace("?", "").split("&");
        let foundSearch = searchArr.find((searchParam) => {
            if (searchParam == "buy-credits=true") {
                return true;
            }
            return searchParam.includes("subscribe=");
        });
        let quantity = searchArr.find((searchParam) => {
            return searchParam.includes("quantity=");
        });
        if (quantity) {
            quantity = quantity.replace("quantity=", "") || 1;
        }
      if (foundSearch) {
        let search;
        if (foundSearch == "buy-credits=true") {
          search = "credits";
        } else {
          search = foundSearch.replace("subscribe=", "");
        }
        if (search != "") {
          if (
            (search == "renew-plan" &&
              (this.state.userProfile == false ||
                JSON.stringify(this.state.userProfile.subscription) == "{}" ||
                !this.state.userProfile.subscription.can_renew)) ||
            (search == "renew-team-plan" &&
              (this.state.userProfile == false ||
                JSON.stringify(this.state.userProfile.team_subscription) ==
                "{}" ||
                !this.state.userProfile.team_subscription.can_renew ||
                !this.state.userProfile.team_subscription.is_team_owner))
          ) {
            return false;
          }
          if (
            search == "credits" &&
            (this.state.userProfile?.subscription?.disable_buy_credits ||
              (this.state.userProfile?.team_subscription?.is_team_member &&
                this.state.userProfile?.team_subscription?.disable_buy_credits))
          ) {
            return false;
          }
          if (
            this.state.userProfile?.team_subscription?.is_team_owner == false
          ) {
            return false;
          }
          if (
            this.state.userProfile?.team_subscription?.plan?.tmc_group == "team"
          ) {
            return false;
          }
          this.setState({
            querySubscribtionID: search,
          });
          if (this.state.selectedSubscribtionID == search) {
            return false;
          }
          let endpoint = `/plans/default`;
          let body = {
            filters: {
              tmc_group: [
                "individual",
                "credit",
                "team",
                "team_credit",
                "student",
                "gift_plan",
                "gift_credit",
              ],
            },
          };
          apiHelpers
            .apiRequest(endpoint, body, "POST", true, token)
            .then((res) => {
              if (res.success) {
                if (search == "credits") {
                  this.showSubscriptionPlan(
                    search,
                    res.data.plans.credit[0],
                    res.data.country
                  );
                  return false;
                }
                if (search == "renew-plan") {
                  this.showSubscriptionPlan(
                    search,
                    this.state.userProfile.subscription.plan,
                    res.data.country
                  );
                  return false;
                }
                if (search == "renew-team-plan") {
                  this.showSubscriptionPlan(
                    search,
                    this.state.userProfile.team_subscription.plan,
                    res.data.country
                  );
                  return false;
                }
                let queryPlan =
                  res.data.plans.individual.find((plan) => plan.id == search) ||
                  res.data.plans.team.find((plan) => plan.id == search) ||
                  res.data.plans.student.find((plan) => plan.id == search) ||
                  res.data.plans.team_credit.find(
                    (plan) => plan.id == search
                  ) ||
                  res.data.plans.gift_credit.find(
                    (plan) => plan.id == search
                  ) ||
                  res.data.plans.gift_plan.find((plan) => plan.id == search);
                if (queryPlan) {
                  if (
                    this.state.userProfile.subscription?.plan &&
                    (queryPlan.tmc_group == "team" ||
                      queryPlan.tmc_group == "team_credit" ||
                      queryPlan.tmc_group == "student")
                  ) {
                    return false;
                  }
                  this.showSubscriptionPlan(
                    search,
                    queryPlan,
                    res.data.country,
                    "",
                    quantity
                  );
                } else {
                  console.log("Plan not found");
                }
              } else {
                console.log("Error=>>", res);
              }
            })
            .catch((error) => {
              console.log("Error=>>", error);
            });
        }
      }
    } else if (
      ((this.props.searchQuery &&
        !(
          this.props.searchQuery.includes("subscribe=") ||
          this.props.searchQuery.includes("buy-credits=true")
        )) ||
        this.props.searchQuery == "") &&
      this.state.querySubscribtionID
    ) {
      this.setState({
        querySubscribtionID: false,
      });
      if (this.state.selectedSubscribtionID == false) {
        return false;
      }
      if (this.refs.submodal) {
        this.refs.submodal.closePlanModal();
      }
    }
  };

  getUserInfo = async (showSubscribtion, subscribtionData) => {
    const { token, documentStatus, documentUploadDate } = this.state;
    let endpoint = `/profile`;
    let body = {
      request_group: ["profile", "subscription", "credits"],
    };
    await apiHelpers
      .apiRequest(endpoint, body, "POST", true, token)
      .then((res) => {
        if (res.code == "access_denied") {
          this.authTokenExpired();
          return false;
        }
        if (res.success) {
          this.props.setUserStatus(res.data.user_status);
          let userSubscription =
            !res.data.subscription ||
              JSON.stringify(res.data.subscription) == "{}"
              ? false
              : res.data.subscription;
          let teamSubscription =
            !res.data.team_subscription ||
              JSON.stringify(res.data.team_subscription) == "{}"
              ? false
              : res.data.team_subscription;
          let showSubscribe =
            (userSubscription && userSubscription.status != "expired") ||
              (teamSubscription &&
                teamSubscription.is_team_member &&
                teamSubscription.status != "expired")
              ? false
              : true;
          let showVerificationModal =
            userSubscription &&
            userSubscription.status == "active" &&
            userSubscription.plan.tmc_group == "student" &&
            (!res.data.document_status ||
              res.data.document_status != "success");

          let userInfo = res.data;
          let privilegedCredits = res.data.credits.privileged_credits;
          let nonPrivilegedCredits = res.data.credits.non_privileged_credits;
          let isUserSubscriptionActive =
            (res.data.subscription &&
              JSON.stringify(res.data.subscription) != "{}" &&
              res.data.subscription.status != "expired") ||
              (res.data.team_subscription &&
                JSON.stringify(res.data.team_subscription) != "{}" &&
                res.data.team_subscription.status != "expired" &&
                res.data.team_subscription.is_team_member)
              ? true
              : false;
          let userSubscriptionStatus =
            !res.data.subscription ||
              JSON.stringify(res.data.subscription) == "{}"
              ? false
              : res.data.subscription.status;
          let freeCreditsAvailable = res.data.free_credits_available;
          console.log("--->dd", isUserSubscriptionActive, userSubscription);

          localStorage.setItem(
            "isUserSubscriptionActive",
            isUserSubscriptionActive == false ||
              String(isUserSubscriptionActive) == "false"
              ? "0"
              : "1"
          );
          localStorage.setItem("userSubscription", userSubscription);

          helpers.setSubscriptionData(
            userInfo,
            privilegedCredits,
            nonPrivilegedCredits,
            isUserSubscriptionActive,
            userSubscriptionStatus,
            userSubscription,
            teamSubscription,
            freeCreditsAvailable
          );
          if (this.props.onLoadData) this.props.onLoadData(userSubscription);
          try {
            Mixpanel.identify(res.data.reference_id);
            let mixpanelObj = {};
            if (userSubscription || teamSubscription) {
              let selectedSubscribtion = userSubscription
                ? userSubscription
                : teamSubscription;
              mixpanelObj["Plan name"] = selectedSubscribtion.plan.name;
              mixpanelObj["Expiry date"] = selectedSubscribtion.end_date;
            }
            if (res.data.credits?.non_privileged_credits) {
              mixpanelObj["Starter credits total"] =
                res.data.credits.non_privileged_credits.total_credits;
              mixpanelObj["Starter credits pending"] =
                res.data.credits.non_privileged_credits.available;
            }
            if (res.data.credits?.privileged_credits) {
              mixpanelObj["Privilege credits total"] =
                res.data.credits.privileged_credits.total_credits;
              mixpanelObj["Privilege credits pending"] =
                res.data.credits.privileged_credits.available;
            }
            if (teamSubscription) {
              mixpanelObj["Corporate user type"] =
                teamSubscription.is_team_owner &&
                  teamSubscription.is_team_member
                  ? "Owner and Member"
                  : teamSubscription.is_team_owner
                    ? "Owner"
                    : "Member";
              if (teamSubscription.is_team_owner) {
                if (teamSubscription.plan.tmc_group == "team") {
                  mixpanelObj["Corporate seats purchased"] =
                    teamSubscription.team_details.seats_purchased;
                  mixpanelObj["Corporate seats used"] =
                    teamSubscription.team_details.seats_purchased -
                    teamSubscription.team_details.seats_available;
                } else {
                  mixpanelObj["Corporate credits total"] =
                    teamSubscription.team_details.credits_purchased;
                  mixpanelObj["Corporate credits pending"] =
                    teamSubscription.team_details.credits_available;
                }
              }
            }
            if (res.data.dark_mode) {
              mixpanelObj["Dark mode web"] = res.data.dark_mode.web;
              mixpanelObj["Dark mode app"] = res.data.dark_mode.app;
            }
            if (JSON.stringify(mixpanelObj) != "{}") {
              Mixpanel.people.set(mixpanelObj);
            }
          } catch (error) {
            console.log("mix panel error =>", error);
          }
          this.setState({
            showUser: true,
            showSubscribe: showSubscribe,
            userProfile: res.data,
            documentUploadDate: res.data.document_uploaded_on,
          });
          this.setDarkMode(
            res.data.dark_mode ? res.data.dark_mode.web : "default",
            res.data.dark_mode?.webSaved != true
          );
          if (showSubscribtion) {
            const {
              subscribtionID,
              selectedSubscribtion,
              country,
              email,
              quantity,
            } = subscribtionData;
            if (subscribtionID == "renew-plan") {
              if (
                res.data.subscription &&
                JSON.stringify(res.data.subscription) != "{}" &&
                res.data.subscription.can_renew
              ) {
                this.openSubscriptionPlan(
                  subscribtionID,
                  res.data.subscription.plan,
                  country
                );
              }
              return false;
            }
            if (subscribtionID == "renew-team-plan") {
              if (
                res.data.team_subscription &&
                JSON.stringify(res.data.team_subscription) != "{}" &&
                res.data.team_subscription.can_renew &&
                res.data.team_subscription.is_team_owner
              ) {
                this.openSubscriptionPlan(
                  subscribtionID,
                  res.data.team_subscription.plan,
                  country
                );
              }
              return false;
            }
            if (
              subscribtionID == "credits" &&
              (res.data?.subscription?.disable_buy_credits ||
                (res.data?.team_subscription?.is_team_member &&
                  res.data?.team_subscription?.disable_buy_credits))
            ) {
              return false;
            }
            if (
              selectedSubscribtion &&
              selectedSubscribtion.tmc_group == "team" &&
              parseInt(quantity) < 2
            ) {
              return false;
            }
            this.openSubscriptionPlan(
              subscribtionID,
              selectedSubscribtion,
              country,
              email,
              quantity
            );
          } else {
            this.checkQuery();
          }
          if (showVerificationModal) {
            console.log("inside show verification !!!!!!!!!!!!!!");
            this.setState({
              documentStatus: res.data.document_status,
              submittedFiles:
                res.data.document_status &&
                  res.data.document_status == "rejected"
                  ? []
                  : res.data.documents,
              openStudentModal:
                res.data.document_status == false ||
                res.data.document_status == "rejected",
            });
          }
          if (this.props.setCredits) {
            this.props.setCredits(res.data.credits);
          }
        } else {
          console.log("Error=>>", res);
        }
      })
      .catch((error) => {
        console.log("Error=>>", error);
      });
  };

  scrollFunction = () => {
    if (
      document.body.scrollTop > 70 ||
      document.documentElement.scrollTop > 70
    ) {
      this.setState({
        siteText: "TMC",
      });
    } else {
      this.setState({
        siteText: "The Morning Context",
      });
    }
  };

  toggleSlideMenu = (show) => {
    if (show) {
      Animated.timing(this.state.slideMenu, {
        toValue: 0,
        duration: 500,
        delay: 0,
        useNativeDriver: true,
      }).start();
    } else {
      Animated.timing(this.state.slideMenu, {
        toValue: -(windowWidth * 2),
        duration: 300,
        delay: 0,
        useNativeDriver: true,
      }).start();
    }
  };

  toggleSearch = (show) => {
    this.setState({ openSearch: show });
    if (show) {
      Animated.timing(this.state.searchbar, {
        toValue: 0,
        duration: 500,
        delay: 0,
        useNativeDriver: true,
      }).start();
    } else {
      Animated.timing(this.state.searchbar, {
        toValue: -(windowWidth * 2),
        duration: 300,
        delay: 0,
        useNativeDriver: true,
      }).start();
    }
  };
  longreadscreen = () => {
    // alert("news")
    if (helpers.isWeb()) {
      this.props.navigateWeb("/longreads");
    } else {
      this.props.navigateWeb("/longreads");
    }
  };
  newsletterscreen = () => {
    // alert("news")
    if (helpers.isWeb()) {
      this.props.navigateWeb("/newsletters-for-you");
    } else {
      this.props.navigateWeb("/newsletters-for-you");
    }
  };

  viewAllStories = () => {
    this.props.navigateApp("/all-stories");
  };

  longformscreen = () => {
    if (helpers.isWeb()) {
      btnClick = {
        to: "/all-stories",
      };
    } else {
      btnClick = {
        onPress: () => this.viewAllStories(),
      };
    }
  };

  viewScreen = (slug) => {
    Animated.timing(this.state.slideMenu, {
      toValue: -(windowWidth * 2),
      duration: 0,
      delay: 0,
      useNativeDriver: true,
    }).start();

    this.props.navigateWeb("/" + slug.web);
  };

  authTokenExpired = (popup) => {
    let cookieDate = new Date(Date.now() - 1);
    cookies.set("token", "", { path: "/", expires: cookieDate });
    this.props.removeUserToken();
    try {
      Mixpanel.reset();
    } catch (error) {
      console.log("mix panel error =>", error);
    }
    try {
      GoogleAnalytics.event("Account", "logout");
    } catch (error) {
      console.log("google analytics error ==>", error);
    }
    this.props.auth.logout({
      returnTo:
        window.location.origin +
        "/sign-in?redirect=" +
        (this.props.redirectSlugs ? this.props.redirectSlugs.web : "/"),
    });
  };

  logout = (popup) => {
    this.authTokenExpired(popup);
  };

  login = () => {
    Animated.timing(this.state.slideMenu, {
      toValue: -(windowWidth * 2),
      duration: 0,
      delay: 0,
      useNativeDriver: true,
    }).start();

    this.props.navigateWeb("/sign-in?redirect=" + this.props.redirectSlugs.web);
  };

  goToSubscribe = () => {
    if (this.props.isPricing) {
      return false;
    }
    try {
      Mixpanel.track("Clicked subscribe from header");
    } catch (error) {
      console.log("mix panel error =>", error);
    }
    this.props.navigateWeb("/pricing?header=true");
  };

  /*
        showSubscriptionPlan wrapper function
    */

    showSubscriptionPlan = (subscribtionID, selectedSubscribtion, country, email, quantity = 1, themeData = null) =>{
        const { token } = this.state;
        if(!token){
            this._showSubscriptionPlan(subscribtionID, selectedSubscribtion, country, email, quantity, themeData, {});
            return ;
        }
        let endpoint = `/get-checkout-options`;
        let body = {
            "planName": selectedSubscribtion.id
        }
        apiHelpers
            .apiRequest(endpoint, body, "POST", true, token)
            .then((res) => {
                if(res.code === 'access_denied'){

                    this._showSubscriptionPlan(subscribtionID, selectedSubscribtion, country, email, quantity, themeData, {});
                    return ;
                }
                if( !res.success || res.code !== 'checkout_options'){
                    console.log('Assert failed (showSubscriptionPlan:/get-checkout-options):', res.success, res.code);
                    return false;

                }
                const paymentConfig = res.data;

                /*
                    Case 1: upgrade
                */
                if(this.state.userProfile?.subscription?.subscription_id && selectedSubscribtion.billing_enitity_type === 'plan'){

                    let existingSubscriptionId = this.state.userProfile.subscription.subscription_id;
                    if(paymentConfig.checkoutType === 'CB'){

                        // // apply only for advance renewal condition
                        // let advance_renew = {
                        //     terms_to_charge: 1,
                        //     // force_term_reset: true,
                        //     invoice_immediately: true,
                        //     subscription: {
                        //         plan_quantity: quantity,
                        //     },
                        // }

                        let upgrade_plan = {
                            subscription: {
                                plan_id: selectedSubscribtion.id,
                                plan_quantity: quantity
                            }
                        }

                        this.showChargbeePage(this.CB__HostedPage, "checkout_existing", existingSubscriptionId, selectedSubscribtion.id, quantity, upgrade_plan);
                    }else{
                        this._showSubscriptionPlan(subscribtionID, selectedSubscribtion, country, email, quantity, themeData, paymentConfig);
                    }
                }
                else if (paymentConfig.checkoutType === "CB") {
                /*
                    Case 2: new sub checkout using CB
                */
                  this.showChargbeePage(
                    this.CB__HostedPage,
                    "checkout_new",
                    null,
                    selectedSubscribtion.id,
                    quantity
                  );
                } else if (paymentConfig.checkoutType === "TMC") {
                /*
                    Case 3: new sub checkout using TMC
                */
                this._showSubscriptionPlan(
                  subscribtionID,
                  selectedSubscribtion,
                  country,
                  email,
                  quantity,
                  themeData,
                  paymentConfig
                );
                }
            })
      .catch((error) => {
        console.log("Error-catch(showPayment:/get-checkout-options):", error);
      });
  };

  /*
        
    */

  initChargebeeInstance = () => {
    const { chargebeeSite, chargebeeSiteIN, chargebeePublishableKey } =
      this.state;

    if (!chargebeeSite) {
      console.log("CB portal err(chargebeeSite not set)");
      return;
    }
    const CB_Options = {
      site: chargebeeSite,
      publishableKey: chargebeePublishableKey,
    };

    /*
            Open the checkout/portal iframe as redirection in phone view
        */
    if (!helpers.isDesktop()) {
      CB_Options.enableRedirectMode = true;
    }

    /*
            Enable custom domain only for mailtmc CB live site
        */
    if (chargebeeSite == chargebeeSiteIN && process.env.IS_PROD === "True") {
      CB_Options.domain = helpers.CB_CustomDomainIndia;
    }

    window.chargebeeInstance = Chargebee.init(CB_Options);
    window.chargebeeInstance = Chargebee.getInstance();
  };

  /*
        
    */

  setChargebeeSite = () => {
    let {
      billingPlatform,
      chargebeeSiteIN,
      chargebeeSiteKeyIN,
      chargebeeSiteOT,
      chargebeeSiteKeyOT,
      chargebeePubKeyIN,
      chargebeePubKeyOT,
    } = this.state;

    if (!billingPlatform) {
      console.log("No billing platform code to get CB site");
      return;
    }

    const chargebeeSite =
      billingPlatform == "chargebee_india" ? chargebeeSiteIN : chargebeeSiteOT;
    const ChargebeeSiteKey =
      chargebeeSite == chargebeeSiteIN
        ? chargebeeSiteKeyIN
        : chargebeeSiteKeyOT;

    const chargebeePublishableKey =
      chargebeeSite == chargebeeSiteIN ? chargebeePubKeyIN : chargebeePubKeyOT;

    this.setState({
      chargebeeSite: chargebeeSite,
      ChargebeeSiteKey: ChargebeeSiteKey,
      chargebeePublishableKey: chargebeePublishableKey,
    });
  };

  showChargbeePage = (callback, ...params) =>{
    if(callback) callback(...params);
  }

  CB__Portal = (
    portal_section,
    existingSubscriptionId,
    subscribtionID,
    quantity
  ) =>
    /*
        Opens chargebee self-serve portal using /create_portal_session endpoint.
        The response of /create_portal_session is valid for 1 hour,
        and no repeatative calls are made when the portal is closed and opened multiple times
        in the 1 hour window.
        
    */
   
    {

        let forwardOptions = null;
        if(portal_section){
            forwardOptions = {}
            forwardOptions.sectionType = portal_section
            forwardOptions.params = {}
            forwardOptions.params["subscriptionId"] = ChargebeeController.customerInfo.subscription.subscription_id
        }

        ChargebeeController.activatedController().then(cb_handle => {
            console.log('chargebee: _control: ', cb_handle)
            if(!cb_handle){
                throw new Error("CB Handle not inited")
            }
            cb_handle.portal.open(forwardOptions)
        })
    };

    isEmptyDict = (obj) => {
        return Object.keys(obj).length === 0;
    }

    CB__HostedPage = (actionType, existingSubscriptionId, selectedSubscribtionSlug, quantity, hostedObjectParams=null) => {

        let shouldUpdateUrl = ([
            '/pricing',
            '/team-subscription',
            '/student-subscription'
        ].includes(window.location.pathname))? true: false
        ChargebeeController.activatedController().then(cb_handle => {
            if(actionType == 'checkout_new'){
                cb_handle.hosted_page.checkout_new({
                    plan_id: selectedSubscribtionSlug,
                    plan_quantity: quantity
                }, {}, shouldUpdateUrl)
            }
    
            else if(actionType == 'collect_now'){
                cb_handle.hosted_page.collect_now()
            }
    
            else if(actionType == 'checkout_existing'){
                cb_handle.hosted_page.checkout_existing(hostedObjectParams, {}, shouldUpdateUrl)

            }
    
        })

        return;
    }


  /*
        wrap showSubscriptionPlan in new method to add paymentConfig data
    */
  _showSubscriptionPlan = (
    subscribtionID,
    selectedSubscribtion,
    country,
    email,
    quantity = 1,
    themeData = null,
    paymentConfig = {}
  ) => {
    if (this.state.token && this.state.userProfile == false) {
      this.getUserInfo(true, {
        subscribtionID,
        selectedSubscribtion,
        country,
        email,
        quantity,
      });
      return false;
    }
    if (subscribtionID == "renew-plan") {
      if (
        JSON.stringify(this.state.userProfile.subscription) != "{}" &&
        this.state.userProfile.subscription.can_renew
      ) {
        this.openSubscriptionPlan(
          subscribtionID,
          this.state.userProfile.subscription.plan,
          country,
          paymentConfig
        );
      }
      return false;
    }
    if (subscribtionID == "renew-team-plan") {
      if (
        JSON.stringify(this.state.userProfile.team_subscription) != "{}" &&
        this.state.userProfile.team_subscription.can_renew &&
        this.state.userProfile.team_subscription.is_team_owner
      ) {
        this.openSubscriptionPlan(
          subscribtionID,
          this.state.userProfile.team_subscription.plan,
          country
        ),
          paymentConfig;
      }
      return false;
    }
    if (
      subscribtionID == "credits" &&
      (this.state.userProfile?.subscription?.disable_buy_credits ||
        (this.state.userProfile?.team_subscription?.is_team_member &&
          this.state.userProfile?.team_subscription?.disable_buy_credits))
    ) {
      return false;
    }
    if (
      selectedSubscribtion &&
      selectedSubscribtion.tmc_group == "team" &&
      parseInt(quantity) < 2
    ) {
      return false;
    }

    if (window && window.ReactNativeWebView && !themeData) {
      try {
        themeData = cookies.get("themeData");
        if (typeof themeData == "string") {
          themeData = JSON.parse(themeData);
        }
      } catch (error) {
        this.setState({ themeDataError: error });
      }
    }
    if (
      selectedSubscribtion &&
      (selectedSubscribtion.tmc_group == "gift_plan" ||
        selectedSubscribtion.tmc_group == "gift_credit") &&
      !themeData
    ) {
      this.openGiftCardModal(
        subscribtionID,
        selectedSubscribtion,
        country,
        email
      );
      return false;
    }
    this.openSubscriptionPlan(
      subscribtionID,
      selectedSubscribtion,
      country,
      email,
      quantity,
      themeData,
      paymentConfig
    );
  };

  openSubscriptionPlan = (
    subscribtionID,
    selectedSubscribtion,
    country,
    email,
    quantity,
    themeData,
    paymentConfig = {}
  ) => {
    this.setState({
      selectedSubscribtionID: subscribtionID,
      paymentConfig: paymentConfig,
      selectedSubscribtion: selectedSubscribtion,
      country: country,
      subscribeEmail: email ? email : "",
      quantity: quantity,
      themeData: themeData,
    });
    if (
      !window.location.search.includes("subscribe=") &&
      !window.location.search.includes("buy-credits=true")
    ) {
      let pushProp = JSON.parse(JSON.stringify(window.location));
      let searchArr = window.location.search.replace("?", "").split("&");
      let queryParam =
        subscribtionID == "credits"
          ? "buy-credits=true"
          : subscribtionID == "renew-plan" ||
            subscribtionID == "renew-team-plan" ||
            selectedSubscribtion.tmc_group != "team"
            ? `subscribe=${subscribtionID}`
            : `subscribe=${subscribtionID}&quantity=${quantity}`;
      if (searchArr.length > 0 && searchArr[0] != "") {
        pushProp.search += "&" + queryParam;
      } else {
        pushProp.search = "?" + queryParam;
      }
      this.props.history.push(pushProp);
    }
  };

  closeSubscriptionPlanModal = (subscriptionStatus, giftData) => {
    let showGiftSuccess = false;
    let giftReceiver = false;
    if (subscriptionStatus == "success" && giftData) {
      showGiftSuccess = true;
      giftReceiver = giftData.first_name;
    }
    this.setState({
      selectedSubscribtionID: false,
      subscribeEmail: "",
      showGiftSuccess,
      giftReceiver,
      // subscriptionStatus: subscriptionStatus ? subscriptionStatus : false
    });
    let pushProp = JSON.parse(JSON.stringify(window.location));
    let searchArr = window.location.search.replace("?", "").split("&");
    // let searchArr = searchArr.filter((searchParam) => {
    //     return ((searchParam != "buy-credits=true") && !searchParam.includes("subscribe=")) ? true : false;
    // });
    // if (searchArr.length > 0) {
    //     pushProp.search = "?" + searchArr.join("&");
    // } else {
    //     pushProp.search = "";
    // }
    // this.props.history.push(pushProp)

    let searchIndex = searchArr.findIndex((searchParam) => {
      if (searchParam == "buy-credits=true") {
        return true;
      }
      return searchParam.includes("subscribe=");
    });
    let close_modal = searchArr.includes("close-modal=true");
    if (close_modal) {
      let reaplaceProp = JSON.parse(JSON.stringify(window.location));
      reaplaceProp.search = "";
      this.props.history.replace(reaplaceProp);
    } else if (searchIndex >= 0) {
      this.props.history.goBack();
    }
    if ((subscriptionStatus = "success")) {
      if (this.state.token) {
        this.getUserInfo();
      }
      if (this.props.refreshPage) {
        this.props.refreshPage();
      }
      if (this.refs.sidebar) {
        this.refs.sidebar.refreshPlans();
      }
    }
  };

  closeGiftSuccessBox = () => {
    this.setState({ showGiftSuccess: false });
  };

  openAccounts = () => {
    let pushProp = JSON.parse(JSON.stringify(window.location));
    pushProp.hash = "accounts";
    this.props.history.push(pushProp);
  };

  changeHash = (hash) => {
    let pushProp = JSON.parse(JSON.stringify(window.location));
    pushProp.hash = hash;
    this.props.history.push(pushProp);
  };

  navigateToScreen = (pushProp) => {
    this.props.history.push(pushProp);
  };

  closeSideBar = () => {
    let pushProp = JSON.parse(JSON.stringify(window.location));
    pushProp.hash = "";
    this.props.history.push(pushProp);
  };

  seachStory = () => {
    let { searchText } = this.state;
    if (searchText) {
      if (this.props.allStories) {
        this.toggleSlideMenu(false);
        this.setState({ searchText: "" });
        this.props.setSearchText(searchText);
      } else {
        this.props.navigateWeb(`/all-stories?search=${searchText}`);
      }
    }
  };

  trackCateoryClick = (item) => {
    // try {
    //     if (item.link.includes('/category')) {
    //         Mixpanel.track('category', { category_slug: item.link, source_section_type: 'hamberger_menu', });
    //     }
    // }
    // catch (error) {
    //     console.log("mix panel error =>", error);
    // }
  };

  trackBookmarkClick = () => {
    try {
      Mixpanel.track("Clicked reading list from header");
    } catch (error) {
      console.log("mix panel error =>", error);
    }
  };

  openStudentModal = () => {
    this.setState({ openStudentModal: true });
  };

  openGiftCardModal = (
    subscribtionID,
    selectedSubscribtion,
    country,
    email,
    story = null,
    giftCredits
  ) => {
    this.setState({
      showGiftCardModal: true,
      subscriptionData: {
        subscribtionID,
        selectedSubscribtion,
        country,
        email,
        userProfile: this.state.userProfile,
        story,
        giftCredits,
      },
    });
  };

  closeGiftCardModal = () => {
    this.setState({ showGiftCardModal: false });
  };

  closeStudentModal = () => {
    const { token } = this.state;
    let endpoint = `/edit-profile`;
    let body = {
      viewed_document_status: true,
    };
    apiHelpers
      .apiRequest(endpoint, body, "POST", true, token)
      .then((res) => {
        if (res.success) {
          this.setState({
            openStudentModal: false,
            documentStatus: "success",
          });
        } else {
          console.log("Error=>>", res);
        }
      })
      .catch((error) => {
        console.log("Error=>>", error);
      });
  };

  closeVerificationModal = (filesSubmitted) => {
    this.setState({
      openStudentModal: false,
    });
    if (this.state.token && filesSubmitted) {
      this.getUserInfo();
    }
    if (this.props.refreshPage) {
      this.props.refreshPage();
    }
    if (this.refs.sidebar) {
      this.refs.sidebar.refreshPlans();
    }
  };

  openAppLink = () => {
    let os = helpers.getMobileOperatingSystem();
    if (os == "Android" || os == "iOS") {
      window.location.href = "https://tmcstageapp.page.link/open-app";
    } else {
      console.log("OS not supported for dynamic linking");
    }
  };

  setGiftSuccess = (giftData) => {
    let showGiftSuccess = false;
    let giftReceiver = false;
    if (giftData) {
      showGiftSuccess = true;
      giftReceiver = giftData.first_name;
    }
    this.setState({ showGiftSuccess, giftReceiver });
    if (giftData.gift_credits && this.props.updateFreeCreditAvailable) {
      this.props.updateFreeCreditAvailable(giftData.gift_credits);
    }
    if (this.refs.sidebar) {
      this.refs.sidebar.refreshPlans();
    }
  };

  goBack = () => {
    if (this.state.locationHash == "#accounts") {
      this.closeSideBar();
      return;
    } else if (this.state.locationHash == "#accounts/subscriptions") {
      this.navigateToScreen("#accounts");
      return;
    }
    this.props.history.goBack();
  };

  render() {
    let longform;
    if (helpers.isWeb()) {
      longform = {
        to: "/longform",
      };
    } else {
      longform = {
        onPress: () => this.viewAllStories(),
      };
    }
    const {
      showToken,
      token,
      userProfile,
      showLogin,
      showUser,
      showSubscribe,
      selectedSubscribtionID,
      selectedSubscribtion,
      subscriptionStatus,
      subscribeEmail,
      country,
      locationHash,
      menuItems,
      searchText,
      quantity,
      copyright,
      showModal,
      showStatus,
      readingValue,
      documentStatus,
      submittedFiles,
      openStudentModal,
      documentUploadDate,
      showGiftCardModal,
      subscriptionData,
      themeData,
      showGiftSuccess,
      giftReceiver,
      paymentConfig,
    } = this.state;

    let { hideMenu, hideHeader, darkMode, isAdmin, referenceId } = this.props;
    let btnClickFB,
      btnClickTwitter,
      btnClickLinkdin,
      btnClickTerms,
      btnClickPrivacy,
      searchClose,
      searchBtnProps,
      btnHomeClick,
      btnBookmarkClick;
    btnClickFB = {
      href: "https://www.facebook.com/Morningcontext/",
    };
    btnClickTwitter = {
      href: "https://twitter.com/MorningContext",
    };
    btnClickLinkdin = {
      href: "https://www.linkedin.com/company/the-morning-context",
    };
    btnClickTerms = {
      to: "/terms-and-conditions",
    };
    btnClickPrivacy = {
      to: "/privacy-policy",
    };
    searchBtnProps = {
      onPress: () => this.seachStory(),
    };
    searchClose = {
      onPress: () => this.toggleSearch(false),
    };
    btnHomeClick = {
      to: "/",
    };
    btnBookmarkClick = {
      to: "/bookmarks",
      handleClick: () => this.trackBookmarkClick(),
    };
    return (
      <>
        {showGiftCardModal && (
          <GiftCardModal
            darkMode={darkMode}
            closeGiftCardModal={() => {
              this.closeGiftCardModal();
            }}
            token={token}
            subscriptionData={subscriptionData}
            showSubscriptionPlan={(
              subscribtionId,
              subscribtion,
              country,
              email,
              quantity,
              themeInfo
            ) =>
              this.showSubscriptionPlan(
                subscribtionId,
                subscribtion,
                country,
                email,
                quantity,
                themeInfo
              )
            }
            setGiftSuccess={this.setGiftSuccess}
          />
        )}

        {openStudentModal && (
          <VerifyDocumentModal
            documentStatus={documentStatus}
            submittedFiles={submittedFiles}
            token={token}
            closeModal={() => { }}
            openStudentModal={openStudentModal}
            closeVerificationModal={(filesSubmitted) =>
              this.closeVerificationModal(filesSubmitted)
            }
            userProfile={userProfile}
            navigateToScreen={(pushProp) => this.navigateToScreen(pushProp)}
            documentUploadDate={documentUploadDate}
            darkMode={darkMode}
            logout={this.logout}
          />
        )}

        {token && locationHash != undefined && locationHash != "" && (
          <SidebarCheck
            ref="sidebar"
            showCBPortal={(
              portal_section,
              existingSubscriptionId,
              subscribtionID,
              quantity
            ) => {
              this.showChargbeePage(
                this.CB__Portal,
                portal_section,
                existingSubscriptionId,
                subscribtionID,
                quantity
              );
            }}
            closeSideBar={() => this.closeSideBar()}
            hash={locationHash.replace("#", "")}
            changeHash={(hash) => this.changeHash(hash)}
            navigateToScreen={(pushProp) => this.navigateToScreen(pushProp)}
            goBack={this.goBack}
            showSubscriptionPlan={(subscribtionId, subscribtion, country) =>
              this.showSubscriptionPlan(subscribtionId, subscribtion, country)
            }
            logout={this.logout}
            isAdmin={isAdmin ? true : false}
            referenceId={referenceId}
            darkMode={darkMode}
            openGiftCardModal={(
              subscribtionID,
              selectedSubscribtion,
              country
            ) =>
              this.openGiftCardModal(
                subscribtionID,
                selectedSubscribtion,
                country
              )
            }
            history={this.props.history}
          />
        )}

        {selectedSubscribtionID && (
          <SubscriptionPlanModal
            ref="submodal"
            planData={selectedSubscribtion}
            paymentConfig={paymentConfig}
            email={subscribeEmail}
            country={country}
            userProfile={userProfile}
            closeModal={(status, giftData) =>
              this.closeSubscriptionPlanModal(status, giftData)
            }
            logout={() => this.logout(true)}
            renewPlan={
              selectedSubscribtionID == "renew-plan" ||
                selectedSubscribtionID == "renew-team-plan"
                ? true
                : false
            }
            buyCredits={
              selectedSubscribtionID == "credits" ||
                selectedSubscribtion.tmc_group == "team_credit"
                ? true
                : false
            }
            isTeam={
              selectedSubscribtion.tmc_group == "team" ||
                selectedSubscribtion.tmc_group == "team_credit"
                ? true
                : false
            }
            navigateWeb={(slug) => this.props.navigateWeb(slug)}
            navigateApp={(slug, params) => this.props.navigateApp(slug, params)}
            quantity={quantity}
            giftPlan={
              selectedSubscribtion.tmc_group == "gift_plan" ||
              selectedSubscribtion.tmc_group == "gift_credit"
            }
            themeData={themeData}
          />
        )}

        {/* Start of the Header view */}
        <Animated.View
          style={[
            { transform: [{ translateY: showModal }] },
            appHeader.wrapper,
            helpers.isDesktop() && appHeader.wrapperDesktop,
            { position: "fixed", left: 0, right: 0, top: -1, zIndex: 999 },
            !helpers.isDesktop() && { height: 56 },
            darkMode && { backgroundColor: Colors.darkHeaderColor },
          ]}
        >
          {!hideMenu && (
            <View
              style={[
                Flex.row,
                Flex.alignCenter,
                helpers.isDesktop() && { width: "30.33%" },
                !helpers.isDesktop() && { width: 30 },
              ]}
            >
              {/* {
                                helpers.isDesktop() &&
                                <TouchableOpacity style={[Margin.mr_2, { paddingHorizontal: 14, paddingVertical: 10 }, helpers.isDesktop() && { borderColor: '#DDDDDD', borderWidth: 1 }]} activeOpacity={0.8}>
                                    <CustomImage
                                        require={true}
                                        source={searchIcon}
                                        webStyle={{
                                            width: 18,
                                            height: 18,
                                        }}
                                        style={[appHeader.searchIcon]} />
                                </TouchableOpacity>
                            } */}

              {helpers.isDesktop() ? (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-evenly",
                  }}
                >
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      Padding.ph_1,
                      {
                        borderColor: "#DDDDDD",
                        borderWidth: 1,
                        paddingVertical: 3,
                        height: 36,
                      },
                    ]}
                  >
                    <TouchableOpacity
                      style={{ paddingRight: 10, paddingVertical: 5 }}
                      onPress={() => this.toggleSlideMenu(true)}
                      activeOpacity={0.8}
                    >
                      <CustomImage
                        require={true}
                        source={darkMode ? menuIconDeskDark : menuIconDesk}
                        webStyle={{
                          width: 20,
                          height: 21,
                        }}
                        style={[appHeader.menuIcon]}
                      />
                    </TouchableOpacity>
                    {/* <Text style={[Typo.infoText, Helpers.textUppercase, { letterSpacing: 1 }]}>{this.state.siteText}</Text> */}
                    <TouchableOpacity
                      style={{ paddingVertical: 5 }}
                      onPress={() => this.toggleSlideMenu(true)}
                      activeOpacity={0.8}
                    >
                      <Animated.Text
                        style={[
                          Typo.infoText,
                          Helpers.textUppercase,
                          { letterSpacing: 1 },
                          darkMode && { color: Colors.lightWhite },
                        ]}
                      >
                        {/* {this.state.siteText} */} MENU
                      </Animated.Text>
                    </TouchableOpacity>
                  </View>
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      Padding.ph_1,
                      {
                        left: 20,
                        borderColor: "#DDDDDD",
                        borderWidth: 1,
                        paddingVertical: 3,
                        paddingHorizontal: 10,
                        height: 36,
                      },
                    ]}
                  >
                    <TouchableOpacity
                      style={{ padding: 0 }}
                      onPress={() => this.toggleSearch(true)}
                      activeOpacity={0.8}
                    >
                      <CustomImage
                        require={true}
                        source={darkMode ? searchIcon : searchIcon}
                        webStyle={{
                          width: 15,
                          height: 15,
                        }}
                        style={[appHeader.menuIcon]}
                      />
                    </TouchableOpacity>
                  </View>
                  {this.state.openSearch ? (
                    <Animated.View
                      style={[
                        appHeader.searchWrapper,
                        helpers.isDesktop() && appHeader.menuWrapperDesktop,
                        {
                          transform: [{ translateX: this.state.searchbar }],
                          maxWidth: 450,
                        },
                        !helpers.isDesktop() && { position: "fixed" },
                        darkMode && {
                          backgroundColor: Colors.darkBlackColorBg,
                        },
                      ]}
                    >
                      {this.state.searchText !== "" ? (
                        <TouchableOpacity
                          style={{ alignSelf: "center" }}
                          {...searchBtnProps}
                        >
                          <View style={[formStyle.searchBox]}>
                            <CustomImage
                              source={searchBox}
                              require={true}
                              style={{ width: 45, height: 40 }}
                              webStyle={{ width: 45, height: 40 }}
                            />
                          </View>
                        </TouchableOpacity>
                      ) : (
                        <TouchableOpacity
                          style={{ alignSelf: "center" }}
                          onPress={() => {
                            this.toggleSearch(false);
                          }}
                        >
                          <View style={[formStyle.searchBox]}>
                            <CustomImage
                              source={darkMode ? closeIconWhite : closeIcon}
                              require={true}
                              style={{ width: 13, height: 13 }}
                              webStyle={{
                                width: 13,
                                height: 13,
                                marginLeft: -20,
                              }}
                            />
                          </View>
                        </TouchableOpacity>
                      )}
                      <TextInput
                        placeholder={"Search"}
                        placeholderTextColor={Colors.placeholderTextColor}
                        style={[
                          Padding.pl_15,
                          {
                            borderWidth: 1,
                            borderColor: "#907CFF",
                            height: 40,
                            flex: 1,
                            paddingRight: 45,
                            fontSize: 14,
                            fontFamily: FontFamily.regular,
                          },
                          darkMode && { color: Colors.lightWhite },
                        ]}
                        onChangeText={(value) =>
                          this.setState({ searchText: value })
                        }
                        value={searchText}
                        onSubmitEditing={this.seachStory}
                      />
                    </Animated.View>
                  ) : (
                    <View
                      style={[
                        Flex.row,
                        Flex.alignCenter,
                        Padding.ph_1,
                        { left: 30, paddingVertical: 3, paddingHorizontal: 3 },
                      ]}
                    >
                      <TouchableOpacity
                        style={{ paddingVertical: 5 }}
                        onPress={() => this.longreadscreen()}
                        activeOpacity={0.8}
                      >
                        <Animated.Text
                          style={[
                            Typo.infoText,
                            Helpers.textUppercase,
                            {
                              letterSpacing: 1,
                              fontSize: 15,
                              fontWeight: 400,
                              marginTop: 5,
                            },
                            darkMode && { color: Colors.lightWhite },
                          ]}
                        >
                          {/* {this.state.siteText} */} LONGREADS
                        </Animated.Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        style={{ paddingVertical: 5, left: 10 }}
                        onPress={() => this.newsletterscreen()}
                        activeOpacity={0.8}
                      >
                        <Animated.Text
                          style={[
                            Typo.infoText,
                            Helpers.textUppercase,
                            {
                              letterSpacing: 1,
                              fontSize: 15,
                              fontWeight: 400,
                              marginTop: 5,
                            },
                            darkMode && { color: Colors.lightWhite },
                          ]}
                        >
                          {/* {this.state.siteText} */} NEWSLETTERS
                        </Animated.Text>
                      </TouchableOpacity>
                    </View>
                  )}
                </View>
              ) : (
                <>
                  <TouchableOpacity
                    style={{ paddingVertical: 10 }}
                    onPress={() => this.toggleSlideMenu(true)}
                    activeOpacity={0.8}
                  >
                    <CustomImage
                      require={true}
                      source={darkMode ? menuIconMobDark : menuIconMob}
                      webStyle={{
                        width: 24,
                        height: 24,
                      }}
                      style={[appHeader.menuIcon]}
                    />
                  </TouchableOpacity>
                  {!helpers.isDesktop() && (
                    <View style={[Flex.row, Flex.alignCenter, { left: 10 }]}>
                      <CustomImage
                        require={true}
                        source={appLogo}
                        altText={"The Morning Context"}
                        webStyle={{
                          width: 40,
                          height: 40,
                          position: "relative",
                          zIndex: 99,
                        }}
                        style={[appHeader.logo]}
                      />
                      {/* Mobilewebview */}
                      <View
                        style={{
                          alignItems: "center",
                          marginLeft: 5,
                          width: 60,
                          height: 30,
                        }}
                      >
                        <TouchableOpacityLink {...btnHomeClick}>
                          {helpers.isDesktop() ? (
                            <Image
                              style={{ width: 60, height: 27 }}
                              source={require("../../../../assets/icons/TMCLogo@3x.png")}
                            />
                          ) : (
                            <>
                              <View>
                                <Text
                                  style={[
                                    Helpers.textUppercase,
                                    {
                                      fontSize: 10,
                                      lineHeight: 10,
                                      fontFamily: FontFamily.regular,
                                      letterSpacing: "0.05em",
                                      whiteSpace: "nowrap",
                                      marginLeft: 0,
                                      color: "#051462",
                                    },
                                    darkMode && { color: Colors.lightWhite },
                                  ]}
                                >
                                  The
                                </Text>
                              </View>
                              <View>
                                <Text
                                  style={[
                                    Helpers.textUppercase,
                                    {
                                      fontSize: 10,
                                      lineHeight: 10,
                                      fontFamily: FontFamily.regular,
                                      letterSpacing: "0.05em",
                                      whiteSpace: "nowrap",
                                      marginLeft: 0,
                                      color: "#051462",
                                    },
                                    darkMode && { color: Colors.lightWhite },
                                  ]}
                                >
                                  Morning
                                </Text>
                              </View>
                              <View>
                                <Text
                                  style={[
                                    Helpers.textUppercase,
                                    {
                                      fontSize: 10,
                                      lineHeight: 10,
                                      fontFamily: FontFamily.regular,
                                      letterSpacing: "0.05em",
                                      whiteSpace: "nowrap",
                                      marginLeft: 0,
                                      color: "#051462",
                                    },
                                    darkMode && { color: Colors.lightWhite },
                                  ]}
                                >
                                  Context
                                </Text>
                              </View>
                            </>
                          )}
                        </TouchableOpacityLink>
                      </View>
                    </View>
                  )}
                </>
              )}
            </View>
          )}

          {
            <View
              style={[
                helpers.isDesktop() && {
                  width: "33.33%",
                  alignItems: "center",
                },
                !helpers.isDesktop() && { textAlign: "center" },
                hideMenu && helpers.isDesktop() && { width: "100%" },
              ]}
            >
              {helpers.isDesktop() && (
                <View style={[Flex.row, Flex.alignCenter]}>
                  <CustomImage
                    require={true}
                    source={appLogo}
                    altText={"The Morning Context"}
                    webStyle={{
                      width: 40,
                      height: 40,
                      position: "relative",
                      zIndex: 99,
                    }}
                    style={[appHeader.logo]}
                  />
                  {/* Website */}
                  <View style={{ alignItems: "center", marginLeft: 15 }}>
                    <TouchableOpacityLink {...btnHomeClick}>
                      <View>
                        <Text
                          style={[
                            Helpers.textUppercase,
                            {
                              fontSize: 12,
                              lineHeight: 13,
                              color: "#051462",
                              fontFamily: FontFamily.regular,
                              letterSpacing: "0.05em",
                              whiteSpace: "nowrap",
                              fontWeight: FontWeight.regular,
                            },
                            darkMode && { color: Colors.lightWhite },
                          ]}
                        >
                          The
                        </Text>
                      </View>
                      <View>
                        <Text
                          style={[
                            Helpers.textUppercase,
                            {
                              fontSize: 12,
                              lineHeight: 13,
                              color: "#051462",
                              fontFamily: FontFamily.regular,
                              letterSpacing: "0.05em",
                              whiteSpace: "nowrap",
                              fontWeight: FontWeight.regular,
                            },
                            darkMode && { color: Colors.lightWhite },
                          ]}
                        >
                          Morning
                        </Text>
                      </View>
                      <View>
                        <Text
                          style={[
                            Helpers.textUppercase,
                            {
                              fontSize: 12,
                              lineHeight: 13,
                              color: "#051462",
                              fontFamily: FontFamily.regular,
                              letterSpacing: "0.05em",
                              whiteSpace: "nowrap",
                              fontWeight: FontWeight.regular,
                            },
                            darkMode && { color: Colors.lightWhite },
                          ]}
                        >
                          Context
                        </Text>
                      </View>
                    </TouchableOpacityLink>
                  </View>
                </View>
              )}
            </View>
          }

          <View
            style={[
              Flex.row,
              helpers.isDesktop() && {
                width: "33.33%",
                justifyContent: "flex-end",
              },
              !helpers.isDesktop() && { width: 50, justifyContent: "flex-end" },
            ]}
          >
            {helpers.isDesktop() ? (
              <>
                {((showToken && showLogin) || showSubscribe) &&
                  !this.props.showSubscribeApp && (
                    <View style={[Margin.mr_2]}>
                      <ButtonGradient
                        title={"Subscribe"}
                        rootStyle={{
                          btnWrapper: [button.primaryGradient, { height: 36 }],
                          btnText: [
                            button.primaryGradientText,
                            {
                              fontSize: 14,
                              paddingHorizontal: 25,
                              fontWeight: "500",
                              fontFamily: FontFamily.regular,
                            },
                          ],
                        }}
                        paddingOverride={true}
                        onClick={() => this.goToSubscribe()}
                        darkMode={darkMode}
                      />
                    </View>
                  )}
                {showToken && showLogin && (
                  <Button
                    title={"LOGIN"}
                    rootStyle={{
                      btnWrapper: [
                        darkMode
                          ? button.primaryOutlineSmallDark
                          : button.primaryOutlineSmall,
                        { height: 36, cursor: 'pointer' },
                      ],
                      btnText: [
                        darkMode
                          ? button.primaryOutlineTextSmallDark
                          : button.primaryOutlineTextSmall,
                        { fontWeight: "500", paddingHorizontal: 15 },
                      ],
                    }}
                    onClick={() => this.login()}
                  />
                )}
              </>
            ) : (
              <>
                {showToken && showLogin && (
                  <>
                    <TouchableOpacity
                      style={{ alignSelf: "center", marginRight: 10 }}
                      onPress={() => this.toggleSlideMenu(true)}
                      activeOpacity={0.8}
                    >
                      <View
                        style={[
                          Flex.row,
                          Flex.alignCenter,
                          Margin.ml_1,
                          helpers.isDesktop() && {
                            borderColor: "#DDDDDD",
                            borderWidth: 1,
                            paddingHorizontal: 11,
                            paddingVertical: 11,
                          },
                        ]}
                      >
                        <CustomImage
                          require={true}
                          source={
                            darkMode ? userIconFilledWhite : userIconLight
                          }
                          webStyle={{
                            width: helpers.isDesktop()
                              ? "auto"
                              : darkMode
                                ? "auto"
                                : 21,
                            height: helpers.isDesktop()
                              ? 16
                              : darkMode
                                ? 18
                                : "auto",
                          }}
                        />
                        {helpers.isDesktop() && (
                          <Text
                            style={[
                              Helpers.textUppercase,
                              Margin.ml_1,
                              { fontSize: 13, fontFamily: FontFamily.regular },
                              darkMode && { color: Colors.lightWhite },
                            ]}
                          >
                            {userProfile.name.substring(0, 1)}
                          </Text>
                        )}
                      </View>
                    </TouchableOpacity>
                    <View style={{ flexDirection: "row" }}>
                      {/* <View style={[Flex.row, Flex.alignCenter, Margin.ml_1, Padding.ph_1, {}]}>
                                            <TouchableOpacity
                                                style={{ padding: 5 }}
                                                onPress={() => this.toggleSlideMenu(true)}
                                                activeOpacity={0.8}>
                                                <CustomImage
                                                    require={true}
                                                    source={darkMode ? searchIcon : searchIcon}
                                                    webStyle={{
                                                        width: helpers.isDesktop() ? 'auto' : (darkMode ? 'auto' : 21),
                                                        height: helpers.isDesktop() ? 16 : (darkMode ? 18 : 'auto')
                                                    }}
                                                    style={[appHeader.menuIcon]} />
                                            </TouchableOpacity>
                                        </View> */}
                      <ButtonGradient
                        title={"SIGN IN"}
                        rootStyle={{
                          btnWrapper: [button.primaryGradient, { height: 40 }],
                          btnText: [
                            button.primaryGradientText,
                            {
                              fontSize: 14,
                              paddingHorizontal: 25,
                              fontWeight: "500",
                              fontFamily: FontFamily.regular,
                            },
                          ],
                        }}
                        paddingOverride={true}
                        onClick={() => this.login()}
                        darkMode={darkMode}
                      />
                    </View>
                  </>
                )}
              </>
            )}
            {showUser && (
              <View style={{ marginRight: helpers.isDesktop() ? 30 : 15 }}>
                <TouchableOpacityLink {...btnBookmarkClick}>
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      helpers.isDesktop() && { paddingVertical: 6 },
                      !helpers.isDesktop() && { padding: 4 },
                    ]}
                  >
                    <CustomImage
                      require={true}
                      source={
                        darkMode ? bookmarkMultipleDark : bookmarkMultiple
                      }
                      webStyle={{
                        width: helpers.isDesktop() ? "auto" : 15,
                        height: helpers.isDesktop() ? 28 : "auto",
                      }}
                    />
                    <Animated.View
                      style={{
                        position: "absolute",
                        height: readingValue.interpolate({
                          inputRange: [0, 60],
                          outputRange: helpers.isDesktop() ? [1, 70] : [1, 60],
                        }),
                        width: readingValue.interpolate({
                          inputRange: [0, 60],
                          outputRange: helpers.isDesktop() ? [1, 70] : [1, 60],
                        }),
                        borderRadius: "50%",
                        backgroundColor: "#C4C4C4",
                        zIndex: -1,
                        left: readingValue.interpolate({
                          inputRange: [0, 60],
                          outputRange: helpers.isDesktop()
                            ? [8, -25]
                            : [7, -23],
                        }),
                        opacity: readingValue.interpolate({
                          inputRange: [0, 17, 55, 60],
                          outputRange: [0, 1, 1, 0],
                        }),
                      }}
                    ></Animated.View>
                  </View>
                </TouchableOpacityLink>
              </View>
            )}
            {/* {!helpers.isDesktop() &&
                            <View style={{ marginRight: helpers.isDesktop() ? 30 : 15 }}>
                                <ButtonGradient
                                    title={'Use App'}
                                    rootStyle={{
                                        btnWrapper: [button.primaryGradient, { height: 30 }],
                                        btnText: [button.primaryGradientText, { fontSize: 14, paddingHorizontal: 7, fontWeight: '700', fontFamily: FontFamily.bold }]
                                    }}
                                    paddingOverride={true}
                                    onClick={() => { this.openAppLink() }}
                                    darkMode={darkMode}
                                />
                            </View>
                        } */}

            {showUser ? (
              <View>
                <TouchableOpacity
                  onPress={() => this.openAccounts()}
                  activeOpacity={0.8}
                >
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      {
                        backgroundColor: "#FC876D",
                        paddingHorizontal: helpers.isDesktop() ? 13 : 8,
                        paddingVertical: helpers.isDesktop() ? 6 : 3.5,
                        borderRadius: 30,
                      },
                    ]}
                  >
                    {/* {!helpers.isDesktop() && <CustomImage
                                            require={true}
                                            source={darkMode ? userIconFilledWhite : userIcon}
                                            webStyle={{
                                                width: helpers.isDesktop() ? 'auto' : 16,
                                                height: helpers.isDesktop() ? 16 : 'auto', marginTop: 1
                                            }} />} */}

                    <Text
                      style={[
                        Helpers.textUppercase,
                        {
                          fontFamily: FontFamily.abrilFatface,
                          fontWeight: "400",
                          color: "#000",
                          fontSize: helpers.isDesktop() ? 22 : 18,
                          lineHeight: helpers.isDesktop() ? 29 : 22,
                        },
                      ]}
                    >
                      {userProfile.name.substring(0, 1)}
                    </Text>
                  </View>
                </TouchableOpacity>
              </View>
            ) : (
              <View style={[{ width: "auto", height: 19 }]}></View>
            )}
          </View>
        </Animated.View>

        {/* End of the Header view */}

        {/* Start of the hamburger menu */}

        {process.browser && (
          <Animated.View
            style={[
              appHeader.menuWrapper,
              helpers.isDesktop() && appHeader.menuWrapperDesktop,
              {
                transform: [{ translateX: this.state.slideMenu }],
                width: "100%",
                maxWidth: 450,
              },
              !helpers.isDesktop() && { position: "fixed" },
              darkMode && { backgroundColor: Colors.darkBlackColorBg },
            ]}
          >
            <View
              style={[
                Flex.row,
                Flex.justifyBetween,
                Flex.alignCenter,
                Padding.pb_2,
              ]}
            >
              <View style={{ alignItems: "center", marginLeft: 15 }}>
                <TouchableOpacityLink {...btnHomeClick}>
                  <View>
                    <Text
                      style={[
                        Helpers.textUppercase,
                        {
                          fontSize: 16,
                          lineHeight: 17,
                          color: "#051462",
                          fontFamily: FontFamily.regular,
                          letterSpacing: "0.05em",
                          whiteSpace: "nowrap",
                          fontWeight: FontWeight.regular,
                        },
                        darkMode && { color: Colors.lightWhite },
                      ]}
                    >
                      The
                    </Text>
                  </View>
                  <View>
                    <Text
                      style={[
                        Helpers.textUppercase,
                        {
                          fontSize: 16,
                          lineHeight: 17,
                          color: "#051462",
                          fontFamily: FontFamily.regular,
                          letterSpacing: "0.05em",
                          whiteSpace: "nowrap",
                          fontWeight: FontWeight.regular,
                        },
                        darkMode && { color: Colors.lightWhite },
                      ]}
                    >
                      Morning
                    </Text>
                  </View>
                  <View>
                    <Text
                      style={[
                        Helpers.textUppercase,
                        {
                          fontSize: 16,
                          lineHeight: 17,
                          color: "#051462",
                          fontFamily: FontFamily.regular,
                          letterSpacing: "0.05em",
                          whiteSpace: "nowrap",
                          fontWeight: FontWeight.regular,
                        },
                        darkMode && { color: Colors.lightWhite },
                      ]}
                    >
                      Context
                    </Text>
                  </View>
                </TouchableOpacityLink>
              </View>
              <TouchableOpacity
                onPress={() => this.toggleSlideMenu(false)}
                activeOpacity={0.8}
                style={{ paddingLeft: 15 }}
              >
                <CustomImage
                  source={darkMode ? closeIconWhite : closeIcon}
                  require={true}
                  webStyle={{ width: 15, height: 15, marginBottom: 3 }}
                  style={{ width: 15, height: 15, marginBottom: 3 }}
                />
              </TouchableOpacity>
            </View>
            <View style={[Margin.mt_2, Margin.mb_4, { position: "relative" }]}>
              <TextInput
                placeholder={"Search"}
                placeholderTextColor={Colors.placeholderTextColor}
                style={[
                  Padding.pl_15,
                  {
                    borderWidth: 1,
                    borderColor: "#907CFF",
                    height: 40,
                    width: "100%",
                    paddingRight: 45,
                    fontSize: 14,
                    fontFamily: FontFamily.regular,
                  },
                  darkMode && { color: Colors.lightWhite },
                ]}
                onChangeText={(value) => this.setState({ searchText: value })}
                value={searchText}
                onSubmitEditing={this.seachStory}
              />
              <TouchableOpacity {...searchBtnProps}>
                <View style={[formStyle.searchBox]}>
                  <CustomImage
                    source={searchBox}
                    require={true}
                    style={{
                      width: 45,
                      height: 40,
                      position: helpers.isDesktop() ? "absolute" : "relative",
                      right: 0,
                      top: -46,
                    }}
                    webStyle={{
                      width: 45,
                      height: 40,
                      position: "absolute",
                      right: 0,
                      top: -40,
                    }}
                  />
                </View>
              </TouchableOpacity>
            </View>
            {menuItems &&
              menuItems.length != 0 &&
              menuItems.map((menu, index) => {
                return (
                  <View style={[index != 0 && Margin.mt_5]}>
                    <Text
                      style={[
                        Helpers.textUppercase,
                        Margin.mb_15,
                        {
                          color: "#999999",
                          fontSize: 14,
                          lineHeight: 17,
                          fontFamily: FontFamily.regular,
                          borderBottomWidth: 1,
                          borderColor: "rgba(0,0,0,0.3)",
                          paddingBottom: 8,
                        },
                        darkMode && {
                          color: Colors.lineColor,
                          borderBottomColor: Colors.lineColor1,
                        },
                      ]}
                    >
                      {menu.name}
                    </Text>
                    <View style={[Flex.fill]}>
                      {menu["sub-menu"].map((item, index) => {
                        let btnClick;
                        btnClick = {
                          to: item.link,
                        };
                        if (
                          (token && item.access == "private") ||
                          item.access == "public"
                        ) {
                          return (
                            <TouchableOpacityLink
                              {...btnClick}
                              handleClick={() => this.trackCateoryClick(item)}
                              key={`itemmenu_${index}`}
                            >
                              <View
                                style={[
                                  appHeader.menuItem,
                                  Flex.row,
                                  Flex.justifyBetween,
                                  Flex.alignCenter,
                                ]}
                              >
                                <View
                                  style={[
                                    Padding.pb_15,
                                    {
                                      width: helpers.isDesktop() ? 345 : "100%",
                                    },
                                    !helpers.isDesktop() && {
                                      paddingRight: 20,
                                    },
                                  ]}
                                >
                                  <Text
                                    style={[
                                      appHeader.menuItemText,
                                      helpers.isDesktop() &&
                                      appHeader.menuItemTextDesktop,
                                      darkMode && { color: Colors.lightWhite },
                                    ]}
                                  >
                                    {item.name}
                                  </Text>
                                  <Text
                                    style={[
                                      appHeader.menuItemTextDesc,
                                      helpers.isDesktop() &&
                                      appHeader.menuItemTextDescDesktop,
                                      darkMode && { color: Colors.lineColor },
                                    ]}
                                  >
                                    {item.description}
                                  </Text>
                                </View>
                                <CustomImage
                                  source={editProfile}
                                  require={true}
                                  style={{
                                    width: 8,
                                    height: 14,
                                    marginLeft: helpers.isDesktop() ? 0 : -15,
                                  }}
                                  webStyle={{
                                    width: 8,
                                    height: 14,
                                    marginLeft: helpers.isDesktop() ? 0 : -15,
                                  }}
                                />
                              </View>
                            </TouchableOpacityLink>
                          );
                        }
                      })}
                    </View>
                  </View>
                );
              })}
            <View style={[Margin.mt_5]}>
              <View>
                <Text
                  style={[
                    Helpers.textUppercase,
                    Margin.mb_15,
                    {
                      color: "#999999",
                      fontSize: 14,
                      lineHeight: 17,
                      fontFamily: FontFamily.regular,
                      borderBottomWidth: 1,
                      borderColor: "rgba(0,0,0,0.3)",
                      paddingBottom: 8,
                    },
                    darkMode && { borderColor: Colors.lineColor1 },
                  ]}
                >
                  Follow us on
                </Text>
                <View style={[Flex.row, Flex.alignCenter]}>
                  <TouchableOpacityLinkExternal {...btnClickFB} newTab={true}>
                    <View style={[Flex.alignCenter]}>
                      <CustomImage
                        source={darkMode ? FacebookDark : Facebook}
                        require={true}
                        style={{ width: 23, height: 23 }}
                        webStyle={{ width: 23, height: 23 }}
                        altText={"Facebook"}
                        resizeMode="contain"
                      />
                      <Text
                        style={[
                          {
                            color: "rgba(63, 63, 63, 0.8)",
                            fontSize: 13,
                            lineHeight: 16,
                            fontFamily: FontFamily.regular,
                            marginTop: 10,
                          },
                          darkMode && { color: Colors.lineColor },
                        ]}
                      >
                        Facebook
                      </Text>
                    </View>
                  </TouchableOpacityLinkExternal>
                  <View
                    style={[
                      {
                        backgroundColor: "rgba(0, 0, 0, 0.25)",
                        height: 58,
                        width: 0.5,
                        marginHorizontal: 28,
                      },
                      darkMode && { backgroundColor: Colors.lineColor1 },
                    ]}
                  />
                  <TouchableOpacityLinkExternal
                    {...btnClickTwitter}
                    newTab={true}
                  >
                    <View style={[Flex.alignCenter]}>
                      <CustomImage
                        source={darkMode ? TwitterDark : Twitter}
                        require={true}
                        style={{ width: 30, height: 21 }}
                        webStyle={{ width: 30, height: 21 }}
                        altText={"Twitter"}
                        resizeMode="contain"
                      />
                      <Text
                        style={[
                          {
                            color: "rgba(63, 63, 63, 0.8)",
                            fontSize: 13,
                            lineHeight: 16,
                            fontFamily: FontFamily.regular,
                            marginTop: 10,
                          },
                          darkMode && { color: Colors.lineColor },
                        ]}
                      >
                        Twitter
                      </Text>
                    </View>
                  </TouchableOpacityLinkExternal>
                  <View
                    style={[
                      {
                        backgroundColor: "rgba(0, 0, 0, 0.25)",
                        height: 58,
                        width: 0.5,
                        marginHorizontal: 28,
                      },
                      darkMode && { backgroundColor: Colors.lineColor1 },
                    ]}
                  />
                  <TouchableOpacityLinkExternal
                    {...btnClickLinkdin}
                    newTab={true}
                  >
                    <View style={[Flex.alignCenter]}>
                      <CustomImage
                        source={darkMode ? LinkedinDark : Linkedin}
                        require={true}
                        style={{ width: 23, height: 23 }}
                        webStyle={{ width: 23, height: 23 }}
                        altText={"Linkedin"}
                        resizeMode="contain"
                      />
                      <Text
                        style={[
                          {
                            color: "rgba(63, 63, 63, 0.8)",
                            fontSize: 13,
                            lineHeight: 16,
                            fontFamily: FontFamily.regular,
                            marginTop: 10,
                          },
                          darkMode && { color: Colors.lineColor },
                        ]}
                      >
                        Linkedin
                      </Text>
                    </View>
                  </TouchableOpacityLinkExternal>
                </View>
              </View>
              {/* <Text style={[Margin.mt_5, { color: '#3F3F3F', fontSize: 18, fontFamily: FontFamily.regular, lineHeight: 22 }, darkMode && { color: Colors.lightWhite }]}>©{copyright} Slowform Pte Limited </Text>
                            <Text style={[appHeader.text, { color: '#6A6A6A' }, darkMode && { color: Colors.lineColor }]}>68 Circular Road, #02-01, 049422, Singapore</Text> */}

              {/* <View style={[Flex.row, Margin.mt_3, Margin.mb_1, Flex.alignCenter]}>
                            <TouchableOpacityLink {...btnClickTerms}><Text style={[appHeader.text, { color: 'rgba(63, 63, 63, 0.8)', textDecorationLine: 'underline' }]}>Terms of service</Text></TouchableOpacityLink>
                            <View style={[appHeader.dot]}></View>
                            <TouchableOpacityLink {...btnClickPrivacy}><Text style={[appHeader.text, { color: 'rgba(63, 63, 63, 0.8)', textDecorationLine: 'underline' }]}>Privacy policy</Text></TouchableOpacityLink>
                        </View> */}
            </View>
          </Animated.View>
        )}

        {/* End of the hamburger menu */}

        {documentStatus == "approved" && (
          <Animated.View
            style={[
              { opacity: showStatus },
              appHeader.paymentSuccess,
              helpers.isDesktop() && appHeader.paymentSuccessDesktop,
              Flex.row,
              Flex.justifyCenter,
              Flex.alignCenter,
              {
                position: "fixed",
                left: 0,
                right: 0,
                top: helpers.isDesktop() ? 66 : 54,
                zIndex: 2,
              },
            ]}
          >
            <View
              style={[
                !helpers.isDesktop && Flex.fill,
                { flexDirection: "row", alignItems: "center" },
                !helpers.isDesktop() && { width: "100%" },
              ]}
            >
              <CustomImage
                source={whiteTick}
                require={true}
                style={{
                  width: 24,
                  height: 24,
                  objectFit: "contain",
                  marginRight: 10,
                }}
                webStyle={{
                  width: 24,
                  height: 24,
                  objectFit: "contain",
                  marginRight: 10,
                }}
              />

              <View
                style={[
                  Flex.fill,
                  {
                    flexDirection: helpers.isDesktop() ? "row" : "column",
                    flexWrap: "wrap",
                  },
                ]}
              >
                <TouchableOpacity
                  onPress={() => this.openStudentModal()}
                  style={{}}
                  activeOpacity={1}
                >
                  <Text
                    style={[
                      appHeader.msgText,
                      helpers.isDesktop() && appHeader.msgTextDesktop,
                      { fontWeight: "700", fontFamily: FontFamily.bold },
                    ]}
                  >
                    Your student identity documents has been verified
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
            <TouchableOpacity
              onPress={() => this.closeStudentModal()}
              style={{
                position: helpers.isDesktop() ? "absolute" : "absolute",
                right: 18,
              }}
            >
              <CustomImage
                source={closeMsgIcon}
                require={true}
                style={{ width: 14, height: 14 }}
                webStyle={{ width: 14, height: 14 }}
              />
            </TouchableOpacity>
          </Animated.View>
        )}

        {documentStatus == "submitted" && (
          <TouchableOpacity
            onPress={() => this.openStudentModal()}
            activeOpacity={1}
            style={{ position: "relative", zIndex: 1 }}
          >
            <Animated.View
              style={[
                { opacity: showStatus },
                appHeader.paymentFailure,
                helpers.isDesktop() && appHeader.paymentFailureDesktop,
                Flex.row,
                Flex.justifyCenter,
                Flex.alignCenter,
                Flex.fill,
                {
                  position: "fixed",
                  left: 0,
                  right: 0,
                  top: helpers.isDesktop() ? 66 : 54,
                  zIndex: 2,
                },
              ]}
            >
              <View style={[Flex.fill]}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    margin: "auto",
                  }}
                >
                  <CustomImage
                    source={whiteClock}
                    require={true}
                    style={{
                      width: 24,
                      height: 24,
                      objectFit: "contain",
                      marginRight: 10,
                    }}
                    webStyle={{
                      width: 24,
                      height: 24,
                      objectFit: "contain",
                      marginRight: 10,
                    }}
                  />
                  <View
                    style={[
                      Flex.fill,
                      {
                        flexDirection: helpers.isDesktop() ? "row" : "column",
                        flexWrap: "wrap",
                      },
                    ]}
                  >
                    <Text
                      style={[
                        appHeader.msgText,
                        helpers.isDesktop() && appHeader.msgTextDesktop,
                        { fontWeight: "700", fontFamily: FontFamily.bold },
                      ]}
                    >
                      Your student identity documents are under verification
                    </Text>
                  </View>
                </View>
              </View>
            </Animated.View>
          </TouchableOpacity>
        )}

        {showGiftSuccess && (
          <Animated.View
            style={[
              { opacity: showStatus },
              appHeader.paymentSuccess,
              helpers.isDesktop() && appHeader.paymentSuccessDesktop,
              Flex.row,
              Flex.justifyCenter,
              Flex.alignCenter,
              {
                position: "fixed",
                left: 0,
                right: 0,
                top: helpers.isDesktop() ? 66 : 54,
                zIndex: 2,
                paddingBottom: 12,
                paddingTop: 12,
              },
            ]}
          >
            <View
              style={[
                !helpers.isDesktop && Flex.fill,
                { flexDirection: "row", alignItems: "center" },
                !helpers.isDesktop() && { width: "100%" },
              ]}
            >
              <CustomImage
                source={whiteTick}
                require={true}
                style={{
                  width: 24,
                  height: 24,
                  objectFit: "contain",
                  marginRight: 10,
                }}
                webStyle={{
                  width: 24,
                  height: 24,
                  objectFit: "contain",
                  marginRight: 10,
                }}
              />

              <View
                style={[
                  Flex.fill,
                  {
                    flexDirection: helpers.isDesktop() ? "row" : "column",
                    flexWrap: "wrap",
                  },
                ]}
              >
                {/* <Text style={[appHeader.alertMsg, !helpers.isDesktop() && { fontSize: 16 }]}>Your gift was sent to {giftReceiver}</Text> */}
                <Text
                  style={[
                    appHeader.msgText,
                    helpers.isDesktop() && appHeader.msgTextDesktop,
                    {
                      fontWeight: "700",
                      fontFamily: FontFamily.bold,
                      textDecorationLine: "none",
                      position: "relative",
                      top: 2,
                    },
                  ]}
                >
                  Your gift was sent to {giftReceiver}
                </Text>
              </View>
            </View>
            <TouchableOpacity
              onPress={() => this.closeGiftSuccessBox()}
              style={{
                position: helpers.isDesktop() ? "absolute" : "absolute",
                right: 18,
              }}
            >
              <CustomImage
                source={closeMsgIcon}
                require={true}
                style={{ width: 14, height: 14 }}
                webStyle={{ width: 14, height: 14 }}
              />
            </TouchableOpacity>
          </Animated.View>
        )}
        {/*  code will be uncooment when we add band feature to paid User */}
        {/* { (country && country.code == 'IN') ?
                token ? userProfile ?
                <PlanAlert 
                    showPlanAlertBox={userProfile?.subscription?.plan?.id == 'anniversary-special-plan-inr'||userProfile?.subscription?.plan?.id == 'anniversary-special-plan-4' ?false:true} 
                    title={userProfile?.subscription?.subscription_id? "Upgrade":"Subscribe"}
                    userId={userProfile?.reference_id?userProfile?.reference_id:0}
                    />:
                    '':
                    <PlanAlert 
                    showPlanAlertBox={userProfile?.subscription?.plan?.id == 'anniversary-special-plan-inr'||userProfile?.subscription?.plan?.id == 'anniversary-special-plan-4' ?false:true} 
                    title={userProfile?.subscription?.subscription_id? "Upgrade":"Subscribe"}
                    userId={userProfile?.reference_id ?userProfile?.reference_id:0}
                    />
                :""}                 */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { app, user } = state;
  return { app, user };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { removeUserToken, setUserStatus, saveDarkMode, darkModeToggle },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(AuthenticationWrapper(AppHeader));
